export default __webpack_public_path__ + "static/media/reliable.62f5dc71.svg";